import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Folder-Open'}</title>
      <g>
        <path d="M415.8 188.5v43.1h-223.9c-16.9 0-34.5 4.3-53 12.8s-33.2 19.2-44.1 32.2l-90.7 106.4-1.3 1.6c0-.7 0-1.8-.1-3.4-.1-1.5-.1-2.6-.1-3.4v-258.2c0-16.5 5.9-30.7 17.8-42.5 11.8-11.8 26-17.8 42.5-17.8h86.1c16.5 0 30.7 5.9 42.5 17.8 11.8 11.8 17.8 26 17.8 42.5v8.6h146.4c16.5 0 30.7 5.9 42.5 17.8 11.7 11.8 17.6 26 17.6 42.5zm92.3 92.5c0 5.6-2.8 11.5-8.3 17.8l-90.4 106.6c-7.7 9.2-18.5 16.9-32.4 23.3-13.9 6.4-26.8 9.6-38.6 9.6h-292.9c-6.1 0-11.5-1.2-16.3-3.5-4.8-2.3-7.1-6.2-7.1-11.6 0-5.6 2.8-11.5 8.3-17.8l90.4-106.6c7.7-9.1 18.5-16.9 32.4-23.3 13.9-6.4 26.8-9.6 38.6-9.6h292.8c6.1 0 11.5 1.2 16.3 3.5 4.8 2.4 7.2 6.3 7.2 11.6z" />
      </g>
    </Icon>
  )
}
